define(["../../deliveryOverview/monitoringDeliveryOverviewModule", "text!./monitorableMapViewModal.html"],

    function (monitoringDeliveryOverviewModule, template) {
        "use strict";
        return monitoringDeliveryOverviewModule.service("monitorableMapViewModal", ["$modal", "monitoringService", "remoteExceptionHandler", "markerService", "markerImage", function ($modal, monitoringService, remoteExceptionHandler, markerService, markerImage) {
            return function (monitorable) {
                return $modal.open({
                    template: template,
                    size: "xl",
                    controller: ["$scope", function ($scope) {
                        $scope.monitorable = monitorable;
                        $scope.tracking = {
                            truckDevice: {},
                            lastSignal: null,
                            shouldDisplayRealizedPath: true,
                            trackingMonitorablesByClassification: {
                                primary: {
                                    trackingMonitorables: [],
                                    isAllSelected: true,
                                },
                                secondary: {
                                    trackingMonitorables: [],
                                },
                                isPrimaryView: true,
                            }
                        };
                        $scope.configurations = {
                            conditionalHeight: {
                                height: "auto",
                                active: true
                            }
                        }
                    }]
                });
            };
        }]);
    });